import { Component } from 'preact'
import Markdown from 'preact-markdown'

import s from './key-card-section.sass'
import gs from '../generic-sign-up.sass'
import CollapsibleSection from '../collapsible-section'
import GridSelect from '../grid-select'
import { URLS } from '../constants'
import SelectGroup, { TYPE_RADIO } from '../select-group'
import Checkbox from '../../checkbox'
import Label from '../../label'
import { connect } from 'unistore/preact'
import {
  updatePaymentInfo
} from './actions'
import ErrorList from '../error-list'
import Separator from '../separator'
import ActionButton from '../../action-button'
import cx from 'classnames'

class KeyCardSection extends Component {
  handleOnInput (value) {
    this.setState({
      error: undefined
    })

    this.props.updatePaymentInfo('membershipCardDelivery', value)
  }

  onProceed () {
    const { paymentInfo, onCheckbox } = this.props
    this.setState({
      error: undefined,
      integrityError: undefined,
      acceptError: undefined
    })

    if (!paymentInfo.membershipCardDelivery) { // We have to handle this separetly from the form errors.
      this.setState({
        error: new Error('Du har glömt att välja alternativ för kortleverans.')
      })
    } else if (!paymentInfo.allowEmailMarketing || !paymentInfo.acceptTerms) {
      if (!paymentInfo.allowEmailMarketing) {
        this.setState({
          integrityError: 'Du behöver godkänna vår integritetspolicy innan du kan gå vidare.'
        })
      }
      if (!paymentInfo.acceptTerms) {
        this.setState({
          acceptError: 'Du behöver godkänna våra avtalsvillkor innan du kan gå vidare.'
        })
      }
    } else {
      onCheckbox('acceptTerms', true, 'summary')
    }
  }

  render ({
    signUpInput,
    onInput,
    title,
    description,
    inputs,
    paymentInfo,
    updatePaymentInfo,
    clubs,
    ...rest
  }, {
    error,
    integrityError,
    acceptError
  }) {
    const selectedClub = clubs && clubs.find(club => club.id === signUpInput.club)
    const isManned = selectedClub && selectedClub.isManned

    const renderInputs = inputs.filter(input => input.value !== 'pickupAtClub' || isManned)
    const noInputsStyle = `--noInputs: ${renderInputs.length}`
    return (
      <CollapsibleSection
        className={s.keyCardSection}
        {...rest}
      >
        <Separator className={gs.signUpSeparator} />
        <div className={s.content}>
          <h2>{title}</h2>
          <div className={s.description}><Markdown markdown={description || ''} /></div>
          <SelectGroup
            style={noInputsStyle}
            className={s.gridSelect}
            type={TYPE_RADIO}
            onChange={(value) => this.handleOnInput(value)}
            value={paymentInfo.membershipCardDelivery}
          >
            {renderInputs.map((input, key) => <GridSelect key={key} {...input} />)}
          </SelectGroup>

          <div className={s.isMannedMessage}>Du behöver inte vänta på ditt kort. Ladda ner STC-appen idag och kom in på gymmet med hjälp av ditt digitala medlemskort och QR-kodläsaren i appen.</div>

          <div className={s.checkboxList}>
            <div className={s.checkboxRow}>
              <Checkbox
                id='allowEmailMarketing'
                checked={paymentInfo.allowEmailMarketing}
                onChange={(e) => updatePaymentInfo('allowEmailMarketing', e.target.checked)}
                className={cx(integrityError && s.hasError)}
              />
              <Label for='allowEmailMarketing'>Jag bekräftar härmed att jag har tagit del av STC's <a className={gs.signUpLink} href={URLS.privacyPolicy} target='_blank' rel='noopener'>Integritetspolicy</a> och angiven information om den personuppgiftsbehandling som sker inom ramen för mitt medlemskap, samt information om de rättigheter jag har, och hur jag utövar dessa. Jag är medveten om att jag närsomhelst kan avregistrera mig från att motta direktmarknadsföring genom att använda avregistreringslänken eller kontakta STC.</Label>
            </div>
            {integrityError && <div className={s.error}>{integrityError}</div>}
            <div className={s.checkboxRow}>
              <Checkbox
                id='acceptTerms'
                checked={paymentInfo.acceptTerms}
                onChange={(e) => updatePaymentInfo('acceptTerms', e.target.checked)}
                className={cx(acceptError && s.hasError)}
              />
              <Label for='acceptTerms'>Jag godkänner STCs avtalsvillkor, trivsel- och säkerhetsregler samt godkänner att betala i enlighet med mitt valda medlemskap, och dess bindnings- och uppsägningstid. <a className={gs.signUpLink} href={URLS.terms} target='_blank' rel='noopener'>Läs fullständiga villkor och regler här</a></Label>
            </div>
            {acceptError && <div className={s.error}>{acceptError}</div>}
          </div>
          {error && <div className={s.buttonRow}><ErrorList message={error.message} /></div>}
          <div className={s.buttonRow}>
            <ActionButton label='Välj och gå vidare' onClick={() => this.onProceed()} />
          </div>
        </div>
      </CollapsibleSection>
    )
  }
}

export default connect(['signUpInput', 'paymentInfo'], { updatePaymentInfo })(KeyCardSection)



// WEBPACK FOOTER //
// ./components/signup-flow/step-payment/key-card-section.js